import { inject, Injectable } from '@angular/core';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class StoreSelectionService {
  private readonly location: Location = inject(Location);

  isOnStoreSelectionPage(): boolean {
    return this.location.path().split('?')[0] === '';
  }
}
